// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LastCheckTime__root--PPkL {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--secondary-color);
}

    .LastCheckTime__root--PPkL > svg {
        width: 12px;
        height: 12px;
        color: var(--gray-color);
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/LastCheckTime/LastCheckTime.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AAOjC;;IALI;QACI,WAAW;QACX,YAAY;QACZ,wBAAwB;IAC5B","sourcesContent":[".root {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    color: var(--secondary-color);\n\n    > svg {\n        width: 12px;\n        height: 12px;\n        color: var(--gray-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LastCheckTime__root--PPkL`
};
export default ___CSS_LOADER_EXPORT___;
